import { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button, Dialog, Input } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { ToastError, ToastSuccess } from "../../components/Toast";

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #fff;
  padding: 12px;
`;

const Field = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
  margin-bottom: 8px;
`;

const Label = styled.div`
  width: 90px;
  font-size: 14px;
  font-weight: 600;
`;

const PhoneBinding = () => {
  const { navigate } = useNavigation();
  const { apiStore, authStore, walletStore } = useStores();
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [btnText, setBtnText] = useState("获取验证码");
  const [counting, setCounting] = useState(false);
  const timerRef = useRef<any>(null);

  useEffect(() => {
    // 从其他页「请先绑定手机」弹窗跳转时，清掉残留 Dialog
    Dialog.clear();
    return () => clearInterval(timerRef.current);
  }, []);

  if (walletStore.is_phone_verify) {
    return (
      <PageWrap>
        <PageHeader title="绑定手机" />
        <ScrollArea>
          <div style={{ textAlign: "center", padding: 40 }}>
            已绑定手机
            <div style={{ marginTop: 8, fontWeight: 700 }}>
              {walletStore.phone || ""}
            </div>
          </div>
        </ScrollArea>
      </PageWrap>
    );
  }

  const startCount = () => {
    let n = 60;
    setCounting(true);
    setBtnText(`${n}s`);
    timerRef.current = setInterval(() => {
      n -= 1;
      if (n > 0) setBtnText(`${n}s`);
      else {
        clearInterval(timerRef.current);
        setCounting(false);
        setBtnText("获取验证码");
      }
    }, 1000);
  };

  const getSMS = async () => {
    if (counting) return;
    if (!/^1\d{10}$/.test(phone)) return ToastError("请输入正确手机号");
    try {
      const res = await apiStore.getPhoneSms({
        token: authStore.getToken,
        country_code: "86",
        phone,
      });
      if (res?.code === 200 || res?.code === 0) {
        ToastSuccess("已发送");
        startCount();
      } else ToastError((res as any)?.message || "发送失败");
    } catch (e: any) {
      ToastError(e.message);
    }
  };

  const submit = async () => {
    if (!/^1\d{10}$/.test(phone)) return ToastError("请输入正确手机号");
    if (!code) return ToastError("请输入验证码");
    try {
      setLoading(true);
      const res = await apiStore.phoneVerify({
        token: authStore.getToken,
        country_code: "86",
        phone,
        code,
      });
      if (res?.code === 200 || res?.code === 0) {
        await walletStore.getWalletInfo();
        walletStore.setPhoneVerify?.();
        ToastSuccess("绑定成功");
        navigate("PhoneBindingSuccess");
      } else ToastError((res as any)?.message || "绑定失败");
    } catch (e: any) {
      ToastError(e.message || "绑定失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrap>
      <PageHeader title="绑定手机" />
      <ScrollArea>
        <Field>
          <Label>国家/地区</Label>
          <div>+86</div>
        </Field>
        <Field>
          <Label>手机号</Label>
          <Input value={phone} onChange={setPhone} placeholder="请输入手机号码" />
        </Field>
        <Field>
          <Label>验证码</Label>
          <Input value={code} onChange={setCode} placeholder="请输入验证码" />
          <Button size="mini" color="primary" fill="outline" disabled={counting} onClick={getSMS}>
            {btnText}
          </Button>
        </Field>
        <Button color="primary" block loading={loading} style={{ marginTop: 24 }} onClick={submit}>
          确认绑定
        </Button>
      </ScrollArea>
    </PageWrap>
  );
};

export default observer(PhoneBinding);
